import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Heading from 'common/Heading';
import SideNavBar from 'components/SideNavBar';
import styled from 'styled-components';

import React from 'react';

const ContainerDiv = styled.div`
    .MuiBox-root .MuiPaper-root {
        background-color: ${(props) => props.theme.colorWhite};
        color: ${(props) => props.theme.primaryFontColor};
    }

    .MuiDrawer-root .MuiDrawer-paper {
        background-color: ${(props) => props.theme.colorSecondary};
        color: ${(props) => props.theme.colorMenuFont};
    }

    .MuiBox-root {
        background-color: ${(props) => props.theme.colorBackground};
    }

    .selected {
        color: ${(props) => props.theme.colorWhite};
    }

    .MuiListItem-root {
        padding: 20px 20px;
    }

    .borderMenu {
    }
`;
const drawerWidth = 240;
const Reporting = () => {
    return (
        <ContainerDiv>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />

                <AppBar
                    position="fixed"
                    sx={{
                        width: `calc(100% - ${drawerWidth}px)`,
                        ml: `${drawerWidth}px`,
                    }}
                >
                    <Toolbar>
                        <Heading>Dashboard</Heading>
                    </Toolbar>
                </AppBar>

                <SideNavBar></SideNavBar>
                <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}>
                    <Toolbar />
                    WIP
                </Box>
            </Box>
            {/* <Notification message={notification} onClose={clearNotification} />*/}
        </ContainerDiv>
    );
};

export default Reporting;
